import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "./common.service";
import { ApiService } from "./api.service";


@Component({
	selector: 'app-learning-nothing',
	templateUrl: './learning-map-nothing.component.html',
	styleUrls: ['./learning-map-nothing.component.css']
})
export class LearningMapNothingComponent implements OnInit, AfterViewInit {

	@Input() text: string = ""; 
	constructor(private route: ActivatedRoute,
		private router: Router,
		private apiService: ApiService,
		private commonService: CommonService) {}

	ngOnInit() {

  }

	ngAfterViewInit() {
		this.commonService.initPage();
	}

}



// WEBPACK FOOTER //
// ./src/app/learning-map-nothing.component.ts